import { render, staticRenderFns } from "./Beauty_sleep.vue?vue&type=template&id=e35b778e"
import script from "./Beauty_sleep.vue?vue&type=script&lang=js"
export * from "./Beauty_sleep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports